import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import { useCallback } from 'react'
import * as React from 'react'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { useIntl } from 'react-intl'

interface Props {
  benefit: App.LoyaltyBenefit
  tier: App.LoyaltyTier
  title: string
  icon: React.ReactElement
  promotion?: App.LabFeatureFlagResult
}

function AccountDrawerBenefitHighlightItem(props: Props) {
  const { benefit, tier, title, icon, promotion } = props
  const intl = useIntl()

  const getBenefitBadgeLabel = useCallback(
    (benefit: App.LoyaltyBenefit): string | undefined => {
      const { value, unlimited, remaining } = benefit

      if (value?.unit === 'PERCENTAGE') {
        return `${value.amount}%`
      }

      if (unlimited) {
        return intl.formatMessage({
          id: 'bx_oL2NLaGpopuYDxhtr',
          defaultMessage: 'Unlimited',
          description: 'Label for unlimited loyalty benefit in the loyalty program section',
        })
      }

      if (remaining === 0) {
        return intl.formatMessage({
          id: 'y-wh_Tg11DSHS3YVBBGV',
          defaultMessage: 'Redeemed',
          description: 'Label for redeemed loyalty benefit in the loyalty program section',
        })
      }

      if (typeof remaining === 'number') {
        return `${remaining}x`
      }

      return undefined
    },
    [intl],
  )

  const badgeLabel = getBenefitBadgeLabel(benefit)

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyTextBlock variant="small" startIcon={icon}>
        {title}
      </BodyTextBlock>
      <Group direction="horizontal" verticalAlign="center" gap={12}>
        {promotion?.enabled && (
          <PromotionLabel variant="premium">
            {intl.formatMessage({
              id: 'e0Z582m_IoQRJpc5jXM2',
              defaultMessage: 'New',
              description: 'Label for new loyalty benefit promotion in the loyalty program section',
            })}
          </PromotionLabel>
        )}
        <LoyaltyTierLabel kind="secondary" tier={tier}>
          {badgeLabel && <>{badgeLabel}</>}
        </LoyaltyTierLabel>
      </Group>
    </Group>
  )
}

export default AccountDrawerBenefitHighlightItem
